export const PROCESS = {
  FIRST: 'EAMIL',
  SECOND: 'PASSWORD',
  THIRD: 'FORM',
};
